import { invariant } from '@seen/core/invariant'

// export const MEDPLUM_BASE_URL = 'http://localhost:8103'
export const MEDPLUM_BASE_URL = 'https://api.medplum.com'
export const MEDPLUM_PROJECT_ID = import.meta.env
  .VITE_MEDPLUM_PROJECT_ID as string
export const MEDPLUM_GOOGLE_CLIENT_ID = import.meta.env
  .VITE_MEDPLUM_GOOGLE_CLIENT_ID as string

export const SEEN_API_URL = import.meta.env.VITE_SEEN_API_URL as string
invariant(SEEN_API_URL, 'SEEN_API_URL env var missing')

export const IS_DEV = __APP_ENV__ === 'development'
export const IS_STAGING = __APP_ENV__ === 'preview'
export const IS_PROD = __APP_ENV__ === 'production'

export const ELATION_URL = import.meta.env.VITE_ELATION_URL as string

export const KNOCK_API_PUBLIC_KEY = import.meta.env
  .VITE_KNOCK_API_PUBLIC_KEY as string
invariant(KNOCK_API_PUBLIC_KEY, 'KNOCK_API_PUBLIC_KEY env var missing')

export const KNOCK_FEED_CHANNEL_ID = import.meta.env
  .VITE_KNOCK_FEED_CHANNEL_ID as string
invariant(KNOCK_FEED_CHANNEL_ID, 'KNOCK_FEED_CHANNEL_ID env var missing')

export const KNOCK_GUIDE_CHANNEL_ID = import.meta.env
  .VITE_KNOCK_GUIDE_CHANNEL_ID as string | undefined

export const LIVEBLOCKS_COPILOT_ID = import.meta.env
  .VITE_LIVEBLOCKS_COPILOT_ID as string
invariant(LIVEBLOCKS_COPILOT_ID, 'LIVEBLOCKS_COPILOT_ID env var missing')

export const FULLCALENDAR_LICENSE_KEY = import.meta.env
  .VITE_FULLCALENDAR_LICENSE_KEY as string

export const APP_VERSION = (import.meta.env.VITE_APP_VERSION ??
  document
    .querySelector('meta[name="app-version"]')
    ?.getAttribute('content')) as string
export const APP_COMMIT_SHA = (import.meta.env.VITE_APP_COMMIT_SHA ??
  document
    .querySelector('meta[name="app-commit-sha"]')
    ?.getAttribute('content')) as string

export const DATADOG_APPLICATION_ID = import.meta.env
  .VITE_DATADOG_APPLICATION_ID as string
export const DATADOG_CLIENT_TOKEN = import.meta.env
  .VITE_DATADOG_CLIENT_TOKEN as string
export const DATADOG_SITE =
  (import.meta.env.VITE_DATADOG_SITE as string) || 'us3.datadoghq.com'
